import { render, staticRenderFns } from "./DownlinksQueueSection.vue?vue&type=template&id=7f1644f8&scoped=true&"
import script from "./DownlinksQueueSection.vue?vue&type=script&lang=ts&"
export * from "./DownlinksQueueSection.vue?vue&type=script&lang=ts&"
import style0 from "./DownlinksQueueSection.vue?vue&type=style&index=0&id=7f1644f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1644f8",
  null
  
)

export default component.exports